export default __webpack_public_path__ + "static/3_31-a889d9050b311b271c7a0f4994ef3ff4.png";